var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUlotka2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:url(#SVGID_00000106147265124889248930000007579335002767836850_);stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:url(#SVGID_00000170984124748258856130000015397818497124729763_);stroke:#000000;stroke-miterlimit:10;}\r\n\t.st3{fill:url(#SVGID_00000127045766171816608040000003150392881738912953_);stroke:#000000;stroke-miterlimit:10;}\r\n\t.st4{fill:url(#SVGID_00000112621619354842629470000018261074028418906047_);stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{fill:url(#SVGID_00000124157606498455111480000004522317580345280901_);stroke:#000000;stroke-miterlimit:10;}\r\n\t.st6{fill:url(#SVGID_00000073700161546213915310000004740274111884289959_);stroke:#000000;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.7403,
    y1: -5.4047,
    x2: 232.9919,
    y2: 323.2492,
    gradientTransform: "matrix(1 0 0 -1 0 511.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FBA15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4194,
    style: {
      stopColor: "#AAC811"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FBA15"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.5,72.3V412c0,33.6-27.5,61.1-61,61.1H126.7c-5.6,0-11-1-16.2-2.5c7.8,23.7,30,41.1,56.2,41.1h249.9 c32.7,0,59.5-26.8,59.5-59.5V128.8C476.1,102.3,458.5,80,434.5,72.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051377291621427801770000016659375736800331449_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.3312,
    y1: 63.7323,
    x2: 89.3328,
    y2: 517.5269,
    gradientTransform: "matrix(1 0 0 -1 0 511.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FBA15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#AAC811"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FBA15"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051377291621427801770000016659375736800331449_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: " M345.2,0H95.4C62.7,0,35.9,26.8,35.9,59.5V383c0,32.7,26.8,59.5,59.5,59.5h249.9c32.7,0,59.5-26.8,59.5-59.5V59.5 C404.7,26.8,378,0,345.2,0z M364.2,349.8c0,25.7-21.1,46.8-46.8,46.8H120.9c-25.7,0-46.8-21.1-46.8-46.8V95.4 c0-25.7,21.1-46.8,46.8-46.8h196.6c25.7,0,46.8,21.1,46.8,46.8L364.2,349.8L364.2,349.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110460039079280182600000011433243670853472679_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.3678,
    y1: 367.7897,
    x2: 233.9377,
    y2: 441.2808,
    gradientTransform: "matrix(1 0 0 -1 0 511.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FBA15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4194,
    style: {
      stopColor: "#AAC811"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FBA15"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110460039079280182600000011433243670853472679_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: " M319.8,117.5H190.5c-5.4,0-9.8-4.4-9.8-9.8V107c0-5.4,4.4-9.8,9.8-9.8h129.3c5.4,0,9.8,4.4,9.8,9.8v0.7 C329.7,113.1,325.2,117.5,319.8,117.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103237139202883726290000003721693905871821196_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.1092,
    y1: 294.9491,
    x2: 190.1627,
    y2: 398.7795,
    gradientTransform: "matrix(1 0 0 -1 0 511.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FBA15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4194,
    style: {
      stopColor: "#AAC811"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FBA15"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103237139202883726290000003721693905871821196_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: " M319.8,175.2H120.4c-5.4,0-9.8-4.4-9.8-9.8v-0.7c0-5.4,4.4-9.8,9.8-9.8h199.5c5.4,0,9.8,4.4,9.8,9.8v0.7 C329.7,170.7,325.2,175.2,319.8,175.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132799897515466402150000013735328322174038915_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.1187,
    y1: 237.3327,
    x2: 190.1627,
    y2: 341.1795,
    gradientTransform: "matrix(1 0 0 -1 0 511.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FBA15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4194,
    style: {
      stopColor: "#AAC811"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FBA15"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132799897515466402150000013735328322174038915_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: " M319.8,232.8H120.4c-5.4,0-9.8-4.4-9.8-9.8v-0.7c0-5.4,4.4-9.8,9.8-9.8h199.5c5.4,0,9.8,4.4,9.8,9.8v0.7 C329.7,228.4,325.2,232.8,319.8,232.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009585612633850208000000001850518510785167236_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.1187,
    y1: 179.6327,
    x2: 190.1627,
    y2: 283.4796,
    gradientTransform: "matrix(1 0 0 -1 0 511.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FBA15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4194,
    style: {
      stopColor: "#AAC811"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FBA15"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009585612633850208000000001850518510785167236_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: " M319.8,290.5H120.4c-5.4,0-9.8-4.4-9.8-9.8V280c0-5.4,4.4-9.8,9.8-9.8h199.5c5.4,0,9.8,4.4,9.8,9.8v0.7 C329.7,286.1,325.2,290.5,319.8,290.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102539797151611522150000013341317687612416701_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.1092,
    y1: 121.9491,
    x2: 190.1627,
    y2: 225.7795,
    gradientTransform: "matrix(1 0 0 -1 0 511.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FBA15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4194,
    style: {
      stopColor: "#AAC811"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FBA15"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102539797151611522150000013341317687612416701_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: " M319.8,348.2H120.4c-5.4,0-9.8-4.4-9.8-9.8v-0.7c0-5.4,4.4-9.8,9.8-9.8h199.5c5.4,0,9.8,4.4,9.8,9.8v0.7 C329.7,343.7,325.2,348.2,319.8,348.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUlotka2);
export default __webpack_public_path__ + "static/media/ulotka2.6e9c711d58f6d6bbe3f32505ce060179.svg";
export { ForwardRef as ReactComponent };